<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
  import { sysconfkeys } from './request/api'
  export default {
    data() {
      return {

      };
    },
    created() {
      sysconfkeys(['website'])
        .then(res => {
    
          document.title = res.data.website.name
          this.updateMeta('keywords',res.data.website.keyword)
          this.updateMeta('description',res.data.website.keyword)
        })
    },
    watch: {

    },

    mounted() {

    },
    methods: {
      updateMeta(metaName, metaContent) {
        const meta = document.querySelector(`meta[name='${metaName}']`);
        if (meta) {
          meta.setAttribute('content', metaContent);
        } else {
          const newMeta = document.createElement('meta');
          newMeta.setAttribute('name', metaName);
          newMeta.setAttribute('content', metaContent);
          document.head.appendChild(newMeta);
        }
      }
    }
  }
</script>
<style>
  * {
    padding: 0;
    margin: 0;
  }

  body {
    font: 12px Arial, "PingFang SC", "Hiragino Sans GB", STHeiti,
      "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
    font-family: "Microsoft YaHei,Microsoft YaHei-Regular";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }


  [v-cloak] {
    display: none;
  }

  img[src=""] img:not([src]) {
    opacity: 0;
  }

  #app {
    width: 100%;
    height: 100%;
  }

  #nprogress .bar {
    background: #d0a48d !important;
  }

  a {
    text-decoration: none;
  }

  body::-webkit-scrollbar {
    width: 6px;
    flex: 1;
  }

  body::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px #d8d8d8;
    background: #535353;
  }

  body::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px #d8d8d8;
    border-radius: 10px;
    background: #ededed;
  }



  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    vertical-align: inherit !important;
  }

  .rotate-circle,
  .tmap-zoom-control,
  .logo-text {
    display: none;
  }

  .mapcontent div {
    line-height: 28px;
    text-align: left;
    font-size: 16px;

  }

  .mapcontent1 div {
    line-height: 28px;
    text-align: left;
    font-size: 12px;

  }

  .mapcontent {
    background: #0967f9;
    color: #fff;
    padding: 20px;
    border-radius: 4px;
    position: relative;
  }

  .mapcontent1 {
    background: #0967f9;
    color: #fff;
    padding: 10px;
    border-radius: 4px;
    position: relative;
  }

  .trangle {
    width: 0px;
    height: 0px;
    border: 10px solid #000;
    border-top-color: #0967f9;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .el-upload-dragger {
    background: none !important;
    border: none !important;
    height: auto !important;
    border-radius: none !important;
    width: auto !important;
  }

  .tmap-scale-control {
    display: none;
  }

  .cu:hover {
    cursor: pointer;
  }


  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: rgba(55, 196, 168, 1) !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: rgba(55, 196, 168, 1) !important;
    background-color: rgba(55, 196, 168, 1) !important;
  }

  .el-select-dropdown__item.selected {
    color: rgba(55, 196, 168, 1) !important;
  }

  .el-select .el-input.is-focus .el-input__inner {
    color: rgba(55, 196, 168, 1) !important;
    border-color: rgba(55, 196, 168, 1) !important;
  }

  .el-cascader .el-input .el-input__inner:focus,
  .el-cascader .el-input.is-focus .el-input__inner {
    border-color: rgba(55, 196, 168, 1) !important;
  }
  .el-cascader-menu__wrap{
      height: 360px !important;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue